/** Ported from haulsheet index.html ocrParseBoard (Truckstop load board). */
import { OCR_EQUIP, ocrBetterPlace, ocrBlankLoad, ocrCity, ocrIsState, ocrNum, ocrPlacesFromRowText, } from "./shared.js";
export function ocrParseBoard(lines) {
    const rowRe = /\$[\d,]{3,}\s+\$\d+\.\d\d\s+\S+\s+\d{1,2}\/\d{1,2}\b/;
    const rows = lines.filter((l) => rowRe.test(l.text));
    if (!rows.length)
        return [];
    let header = null;
    for (const l of lines) {
        if (/\bRPM\b/.test(l.text) && /Equip/i.test(l.text) && /Pickup/i.test(l.text))
            header = l;
    }
    const defs = [
        ["updated", /^Updated/i],
        ["actions", /^Actions/i],
        ["rate", /^Rate/i],
        ["rpm", /^RPM/i],
        ["equip", /^Equip/i],
        ["pickup", /^Pickup/i],
        ["ocity", /^O-?City/i],
        ["ost", /^O-?St/i],
        ["odh", /^O-?DH/i],
        ["dcity", /^D-?City/i],
        ["dst", /^D-?St/i],
        ["company", /^Company/i],
        ["ddh", /^D-?DH/i],
        ["miles", /^Dista/i],
        ["weight", /^Weight/i],
        ["length", /^Len/i],
        ["width", /^Width/i],
        ["height", /^Height/i],
    ];
    const cols = [];
    if (header) {
        for (const w of header.words) {
            for (const d of defs) {
                if (d[1].test(w.t) && !cols.some((c) => c.k === d[0]))
                    cols.push({ k: d[0], x: w.x });
            }
        }
    }
    cols.sort((a, b) => a.x - b.x);
    const useCols = cols.length >= 8;
    return rows.map((row) => {
        const L = ocrBlankLoad();
        const f = {};
        const tol = row.words[0].h * 0.8;
        if (useCols) {
            for (const w of row.words) {
                let k = null;
                for (const c of cols) {
                    if (c.x <= w.x + tol)
                        k = c.k;
                }
                if (k)
                    f[k] = (f[k] ? f[k] + " " : "") + w.t;
            }
        }
        else {
            const t = row.words.map((w) => w.t);
            let i = 0;
            const tail = [];
            while (i < t.length && !/^\W*\$/.test(t[i]))
                i++;
            f.rate = t[i++];
            f.rpm = t[i++];
            f.equip = t[i++];
            f.pickup = t[i++];
            const oc = [];
            while (i < t.length &&
                !(oc.length && ocrIsState(t[i]) && /^\d+$/.test(t[i + 1] || ""))) {
                oc.push(t[i++]);
            }
            f.ocity = oc.join(" ");
            f.ost = t[i++];
            f.odh = t[i++];
            const dc = [];
            while (i < t.length && !(dc.length && ocrIsState(t[i])))
                dc.push(t[i++]);
            f.dcity = dc.join(" ");
            f.dst = t[i++];
            const rest = t.slice(i);
            while (rest.length && ocrNum(rest[rest.length - 1]))
                tail.unshift(rest.pop());
            f.company = rest.join(" ");
            ["miles", "weight", "length", "width", "height"].forEach((k, n) => {
                f[k] = tail[n] || "";
            });
            L.unreadable.push("No column headings in the screenshot: sizes were matched by position in the row. Check them");
        }
        function numField(k, label) {
            const raw = (f[k] || "")
                .split(/\s+/)
                .filter((tok) => /[A-Za-z0-9]/.test(tok))
                .join(" ");
            if (!raw)
                return "";
            const n = ocrNum(raw);
            if (!n)
                L.unreadable.push(label + ' reads as "' + raw + '": could not make it out');
            return n;
        }
        L.linehaul = numField("rate", "Rate");
        const eq = String(f.equip || "")
            .replace(/[^A-Za-z]/g, "")
            .toUpperCase();
        L.equipment = OCR_EQUIP[eq] || (eq ? eq + " (board code)" : "");
        L.pickup = (String(f.pickup || "").match(/\d{1,2}\/\d{1,2}(\/\d{2,4})?/) || [""])[0];
        const oc2 = ocrCity(f.ocity, "Origin", L);
        const dc2 = ocrCity(f.dcity, "Destination", L);
        let os = String(f.ost || "")
            .replace(/[^A-Za-z]/g, "")
            .toUpperCase();
        let ds = String(f.dst || "")
            .replace(/[^A-Za-z]/g, "")
            .toUpperCase();
        if (!ocrIsState(os)) {
            L.unreadable.push('Origin state reads as "' +
                (f.ost || "") +
                '"' +
                (ocrIsState(os.slice(0, 2)) ? ", used " + os.slice(0, 2) : ""));
            if (ocrIsState(os.slice(0, 2)))
                os = os.slice(0, 2);
        }
        if (!ocrIsState(ds)) {
            L.unreadable.push('Destination state reads as "' +
                (f.dst || "") +
                '"' +
                (ocrIsState(ds.slice(0, 2)) ? ", used " + ds.slice(0, 2) : ""));
            if (ocrIsState(ds.slice(0, 2)))
                ds = ds.slice(0, 2);
        }
        L.origin = oc2 + (os ? ", " + os : "");
        L.destination = dc2 + (ds ? ", " + ds : "");
        const rowPlaces = ocrPlacesFromRowText(row.text);
        if (rowPlaces[0])
            L.origin = ocrBetterPlace(L.origin, rowPlaces[0]);
        if (rowPlaces[1])
            L.destination = ocrBetterPlace(L.destination, rowPlaces[1]);
        L.deadhead = numField("odh", "Deadhead (O-DH)");
        L.miles = numField("miles", "Distance");
        L.weight = numField("weight", "Weight");
        for (const k of ["length", "width", "height"]) {
            const label = k.charAt(0).toUpperCase() + k.slice(1);
            const n = numField(k, label);
            if (n && +n > (k === "length" ? 80 : 16)) {
                L[k] = n + " in";
                L.unreadable.push(label +
                    " shows " +
                    n +
                    " on the board. That is too big for feet, so it is read as inches: check it");
            }
            else
                L[k] = n ? n + " ft" : "";
        }
        const co = String(f.company || "")
            .trim()
            .split(/\s+/);
        if (co.length > 1 && co[0].length === 1)
            co.shift();
        const company = co.join(" ").replace(/^[^A-Za-z0-9]+/, "");
        if (/\.{2,}|…/.test(company)) {
            L.unreadable.push('Broker name is cut off ("' + company.replace(/[.…]+$/, "") + '...")');
        }
        L.ref = "Truckstop" + (company ? ", " + company : "");
        for (const k of ["width", "height", "length"]) {
            if (useCols && cols.some((c) => c.k === k) && !L[k] && !(f[k] || "").trim()) {
                L.unreadable.push(k.charAt(0).toUpperCase() + k.slice(1) + " is blank on the board");
            }
        }
        if (useCols) {
            for (const k of ["length", "width", "height"]) {
                if (!cols.some((c) => c.k === k)) {
                    L.unreadable.push(k.charAt(0).toUpperCase() + k.slice(1) + " column is not in the screenshot");
                }
            }
        }
        L.unreadable.push("Delivery date is not on the board");
        if (L.deadhead)
            L.notes = "Deadhead is the O-DH miles from the board.";
        L._cy = row.cy;
        return L;
    });
}
//# sourceMappingURL=truckstop_board.js.map